var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWf18(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.05124V12.6326C0 13.21 0.47372 13.6838 1.05121 13.6838H18.9488C19.5263 13.6838 20 13.21 20 12.6326V1.05124C20 0.473752 19.5263 3.19607e-05 18.9488 3.19607e-05H1.05121C0.47372 -0.00447966 0 0.46924 0 1.05124ZM3.40176 6.84416H10.8865C11.1753 6.84416 11.4144 7.07876 11.4144 7.37201C11.4144 7.66527 11.1798 7.89987 10.8865 7.89987H3.40176C3.11302 7.89987 2.8739 7.66527 2.8739 7.37201C2.8739 7.07876 3.11302 6.84416 3.40176 6.84416ZM6.27566 10.5256H3.40176C3.11302 10.5256 2.8739 10.291 2.8739 9.99778C2.8739 9.70452 3.1085 9.46992 3.40176 9.46992H6.27566C6.5644 9.46992 6.80352 9.70452 6.80352 9.99778C6.80352 10.291 6.5644 10.5256 6.27566 10.5256ZM16.6028 10.5256H9.11798C8.82923 10.5256 8.59012 10.291 8.59012 9.99778C8.59012 9.70452 8.82472 9.46992 9.11798 9.46992H16.6028C16.8915 9.46992 17.1306 9.70452 17.1306 9.99778C17.1306 10.291 16.8915 10.5256 16.6028 10.5256ZM16.6028 7.89987H13.7289C13.4401 7.89987 13.201 7.66527 13.201 7.37201C13.201 7.07876 13.4356 6.84416 13.7289 6.84416H16.6028C16.8915 6.84416 17.1306 7.07876 17.1306 7.37201C17.1306 7.66527 16.8915 7.89987 16.6028 7.89987Z",
    fill: "#46324E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWf18);
export default __webpack_public_path__ + "static/media/icon-wf-18.9c840402bc37eaf9eab6930bcd2b3793.svg";
export { ForwardRef as ReactComponent };